import { ControlMetadata } from 'app/extensibility/metadatas/control/control-metadata';

import { IRadioOption } from 'app/interfaces/IRadioOption';
export const optionsTrueFalse: Array<IRadioOption<boolean>> = [
    {
        label: stringResources.True,
        value: true
    },
    {
        label: stringResources.False,
        value: false
    }
];

export const optionsOffOn: Array<IRadioOption<boolean>> = [
    {
        label: stringResources.OnLabel,
        value: true
    },
    {
        label: stringResources.OffLabel,
        value: false
    }
];

export const useEncryptedEndpointsRadioSwitch: ControlMetadata = {
    type: 'radio-switch',
    nested: 1,
    bind: 'useEncryptedEndpoints',
    label: stringResources.ModelName_UseEncryptedEndpoints,
    isLabelVertical: true,
    options: optionsTrueFalse,
    defaultValue: true,
    cases: [
        {
            caseValue: true,
            children: [
                {
                    type: 'radio',
                    bind: 'useHostVerification',
                    label: stringResources.ModelName_UseHostVerification,
                    isLabelVertical: true,
                    options: optionsTrueFalse,
                    defaultValue: true
                },
                {
                    type: 'radio',
                    bind: 'usePeerVerification',
                    label: stringResources.ModelName_UsePeerVerification,
                    isLabelVertical: true,
                    options: optionsTrueFalse,
                    defaultValue: true
                }
            ]
        }
    ]
};

export const trustedCertPathTextbox: ControlMetadata = {
    type: 'textbox',
    bind: 'trustedCertPath',
    label: stringResources.ModelName_TrustedCertPath,
    isLabelVertical: true
};

export const useSystemTrustStoreRadio: ControlMetadata = {
    type: 'radio',
    bind: 'useSystemTrustStore',
    label: stringResources.ModelName_UseSystemTrustStore,
    isLabelVertical: true,
    options: optionsTrueFalse,
    defaultValue: false
};

export const allowHostNameCNMismatchRadio: ControlMetadata = {
    type: 'radio',
    bind: 'allowHostNameCNMismatch',
    label: stringResources.ModelName_AllowHostNameCNMismatch,
    isLabelVertical: true,
    options: optionsTrueFalse,
    defaultValue: false
};

export const allowSelfSignedServerCertRadio: ControlMetadata = {
    type: 'radio',
    bind: 'allowSelfSignedServerCert',
    label: stringResources.ModelName_AllowSelfSignedServerCert,
    isLabelVertical: true,
    options: optionsTrueFalse,
    defaultValue: false
};

export const enableSslWithTUAARadioSwitch: ControlMetadata = {
    type: 'radio-switch',
    nested: 1,
    bind: 'enableSsl',
    label: stringResources.ModelName_EnableSSL,
    isLabelVertical: true,
    options: [
        {
            label: stringResources.LinkedService_EnableSSL,
            value: true
        },
        {
            label: stringResources.LinkedService_DisableSSL,
            value: false
        }
    ],
    defaultValue: false,
    cases: [
        {
            caseValue: true,
            children: [
                trustedCertPathTextbox,
                useSystemTrustStoreRadio,
                allowHostNameCNMismatchRadio,
                allowSelfSignedServerCertRadio
            ]
        }
    ]
};

export const enableSslWithTAARadioSwitch: ControlMetadata = {
    type: 'radio-switch',
    nested: 1,
    bind: 'enableSsl',
    label: stringResources.ModelName_EnableSSL,
    isLabelVertical: true,
    options: [
        {
            label: stringResources.LinkedService_EnableSSL,
            value: true
        },
        {
            label: stringResources.LinkedService_DisableSSL,
            value: false
        }
    ],
    defaultValue: false,
    cases: [
        {
            caseValue: true,
            children: [
                trustedCertPathTextbox,
                allowHostNameCNMismatchRadio,
                allowSelfSignedServerCertRadio
            ]
        }
    ]
};

export function blockSizeInMbMetadata(description: string): ControlMetadata {
    return {
        type: 'parameterizable',
        child: {
            type: 'textbox-number',
            bind: 'blockSizeInMB',
            label: stringResources.ModelName_BlockSizeInMB,
            description,
            escapeDescription: false,
            min: 4,
            max: 100,
            validators: [
                {
                    type: 'number',
                    min: 4,
                    max: 100,
                    errorMessage: stringResources.BlockSizeInMB_ErrorMessage
                }
            ]
        },
        dynamicContentTextClass: 'input-spaced'
    };
}

export const enableSslSimplified: ControlMetadata = {
    type: 'radio-switch',
    nested: 1,
    bind: 'enableSsl',
    label: stringResources.ModelName_EnableSSL,
    isLabelVertical: true,
    options: [
        {
            label: stringResources.LinkedService_EnableSSL,
            value: true
        },
        {
            label: stringResources.LinkedService_DisableSSL,
            value: false
        }
    ],
    defaultValue: true,
    cases: [
        {
            caseValue: true,
            children: [
                {
                    type: 'radio',
                    bind: 'enableServerCertificateValidation',
                    label: stringResources.ModelName_EnableServerCertificateValidation,
                    isLabelVertical: true,
                    options: [
                        {
                            label: stringResources.Enable,
                            value: true
                        },
                        {
                            label: stringResources.Disable,
                            value: false
                        }
                    ],
                    defaultValue: true
                }
            ]
        }
    ]
};